<script setup lang="ts">
  import { computed, type HTMLAttributes } from 'vue'
  import type { OverlayScrollbars } from 'overlayscrollbars'
  import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue'
  import { cn } from '@/utils'

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      defer?: boolean
    }>(),
    {
      defer: true
    }
  )

  const emit = defineEmits<{
    (e: 'viewport-ready', viewport: HTMLElement | null): void
  }>()

  const classes = computed(() => cn('relative w-full', props.class))

  const options = {
    scrollbars: {
      autoHide: 'never',
      dragScroll: true,
      clickScroll: true
    }
  } as const

  function handleInitialized(instance: OverlayScrollbars) {
    emit('viewport-ready', instance.elements().viewport)
  }
</script>

<template>
  <OverlayScrollbarsComponent
    :defer="props.defer"
    :options="options"
    :class="classes"
    @os-initialized="handleInitialized"
  >
    <slot />
  </OverlayScrollbarsComponent>
</template>
